
import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import OrientationQuiz from '@/components/application/OrientationQuiz';
import ApplicationStepper from '@/components/application/ApplicationStepper';

const OrientationQuizPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />
        
        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">Orientation Quiz</h1>
        <p className="text-gray-600 mb-8 text-center">
          Test your understanding of our procedures and guidelines
        </p>
        
        <div className="max-w-2xl mx-auto">
          <OrientationQuiz />
        </div>
      </div>
    </AppLayout>
  );
};

export default OrientationQuizPage;
